import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import {
  downloadAppButton,
  hero,
  heroText,
  logo,
  mobileHero,
  mobileHeroText,
  mobileOrderButton,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          column
          justifyBetween
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <Header />
          <CFView
            textCenter
            column
            center
            ph="7%"
            pt="5px"
            w="100%"
            pt="10px"
            bg="rgba(0,0,0,.7)"
            bc="#B88F60"
            bw="1.5px"
          >
            <CFView column center>
              <CFText color="white" hero raleway>
                NOW TAKING ONLINE ORDERS
              </CFText>
            </CFView>
            <CFView pt="10px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          w="100%"
          image={`url(${hero}) bottom/ cover no-repeat`}
          zIndex={90}
          relative
          column
          center
          justifyBetween
        >
          <Header />
          <CFView
            row
            center
            w="100%"
            maxWidth="1200px"
            bg="rgba(0,0,0,.7)"
            bc="#B88F60"
            bw="1.5px"
          >
            <CFView column justifyStart>
              <CFText color="white" hero raleway>
                NOW TAKING ONLINE ORDERS
              </CFText>
            </CFView>
            <CFView pt="10px" ml="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
